"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClassUtil_1 = require("../util/ClassUtil");
var ChainKey_1 = require("./ChainKey");
var CipherKey_1 = require("../derived/CipherKey");
var DerivedSecrets_1 = require("../derived/DerivedSecrets");
var InputError_1 = require("../errors/InputError");
var RootKey = (function () {
    function RootKey() {
        this.key = new CipherKey_1.default();
    }
    RootKey.from_cipher_key = function (cipher_key) {
        var rk = ClassUtil_1.default.new_instance(RootKey);
        rk.key = cipher_key;
        return rk;
    };
    RootKey.prototype.dh_ratchet = function (ours, theirs) {
        var secret = ours.secret_key.shared_secret(theirs);
        var derived_secrets = DerivedSecrets_1.default.kdf(secret, this.key.key, 'dh_ratchet');
        return [RootKey.from_cipher_key(derived_secrets.cipher_key), ChainKey_1.default.from_mac_key(derived_secrets.mac_key, 0)];
    };
    RootKey.prototype.encode = function (encoder) {
        encoder.object(1);
        encoder.u8(0);
        return this.key.encode(encoder);
    };
    RootKey.decode = function (decoder) {
        var cipher_key = null;
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0:
                    cipher_key = CipherKey_1.default.decode(decoder);
                    break;
                default:
                    decoder.skip();
            }
        }
        if (cipher_key) {
            return RootKey.from_cipher_key(cipher_key);
        }
        else {
            throw new InputError_1.default.TypeError("Given RootKey doesn't match expected signature.", InputError_1.default.CODE.CASE_407);
        }
    };
    return RootKey;
}());
exports.RootKey = RootKey;
exports.default = RootKey;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/session/RootKey.js
// module id = 103
// module chunks = 0 1